import React, { useContext, useEffect, useState } from 'react';
import { useSelector } from '@xstate/react';
import { useTranslation } from 'react-i18next';
import { Alert, Column, Heading, Row } from '@chargify/custom-ui-components';
import { CustomField } from '@chargify/custom-fields';

import { customFieldsSelectors } from '../../machines/customFields/selectors';
import { GlobalStateContext } from '../../contexts';
import CustomFields from '../../components/CustomFields';
import CustomFieldsForm from '../../components/CustomFieldsForm';
import { SectionWrapper } from '../CustomerDetailsContainer/CustomerDetailsContainer.styles';

const CustomFieldsContainer = () => {
  const { customFieldsService } = useContext(GlobalStateContext);

  const { isFetchError, isEdit, isSaving, isSaveError } = useSelector(
    customFieldsService,
    customFieldsSelectors.getCustomFieldsState
  );
  const { customFields } = useSelector(
    customFieldsService,
    customFieldsSelectors.getCustomFields
  );

  const { t } = useTranslation(['customer-details']);

  const [editedFields, setEditedFields] = useState<CustomField[]>(null);

  useEffect(() => {
    setEditedFields(customFields);
  }, [customFields]);

  const onFieldValueChange = (id: number, value: string | number) => {
    const fields = [...editedFields];
    const index = fields.findIndex((field) => {
      return field.id === id;
    });
    fields[index] = {
      ...fields[index],
      value: value as string,
    };
    setEditedFields(fields);
  };

  return (
    <>
      {isFetchError && (
        <SectionWrapper paddingTop={7} marginTop={7}>
          <Alert color="danger">
            <Alert.TextMessage>
              {t('error.we_were_unable_to_display_your_custom_fields')}
            </Alert.TextMessage>
          </Alert>
        </SectionWrapper>
      )}
      {customFields && customFields.length > 0 && (
        <SectionWrapper paddingTop={7} marginTop={7}>
          <Row>
            <Column span={[24, 7]}>
              <Heading variant="h4">
                {t('custom_fields.additional_settings')}
              </Heading>
            </Column>
            <Column span={[24, 17]}>
              {isEdit ? (
                <CustomFieldsForm
                  customFields={editedFields}
                  onChange={onFieldValueChange}
                  onSave={() =>
                    customFieldsService.send('SAVE', {
                      fields: editedFields.map(({ id, value }) => ({
                        id,
                        value,
                      })),
                    })
                  }
                  onCancel={() => customFieldsService.send('CANCEL')}
                  isSaving={isSaving}
                  isError={isSaveError}
                />
              ) : (
                <CustomFields
                  customFields={customFields}
                  onEdit={() => customFieldsService.send('EDIT_CUSTOM_FIELDS')}
                />
              )}
            </Column>
          </Row>
        </SectionWrapper>
      )}
    </>
  );
};

export default CustomFieldsContainer;
